import * as qs from 'qs';

/**
 * Device detection regexes are taken from cloudflare
 * https://support.cloudflare.com/hc/en-us/articles/229373388-Cache-Content-by-Device-Type-Mobile-Tablet-Desktop-
 */
const mobileRegex = /(?:phone|windows\s+phone|ipod|blackberry|(?:android|bb\d+|meego|silk|googlebot) .+? mobile|palm|windows\s+ce|opera mini|avantgo|mobilesafari|docomo)/i;
const tabletRegex = /(?:ipad|playbook|(?:android|bb\d+|meego|silk)(?! .+? mobile))/i;

type Device = 'mobile' | 'tablet' | 'desktop';

export function detectDevice(userAgent: string): Device {
    if (mobileRegex.test(userAgent)) {
        return 'mobile';
    } else if (tabletRegex.test(userAgent)) {
        return 'tablet';
    } else {
        return 'desktop';
    }
}

export const isWebView = (queryString: string): boolean => {
    const { isMobileApp } = qs.parse(queryString);
    return isMobileApp ? isMobileApp.toLowerCase() === 'true' : false;
};
